// extracted by mini-css-extract-plugin
export default {"pitstopGif":"CTABanner_pitstopGif__T6E2R"};